/**
 * Select Atom
 *
 * Campo de seleção reutilizável
 */
import React, { forwardRef } from 'react'
import { ChevronDown } from 'lucide-react'

const Select = forwardRef(({
	label,
	error,
	options = [],
	placeholder = 'Selecione...',
	className = '',
	...props
}, ref) => {
	return (
		<div className={className}>
			{label && (
				<label className="block text-sm font-medium text-text-body mb-1">
					{label}
				</label>
			)}
			<div className="relative">
				<select
					ref={ref}
					className={`
            block w-full rounded-lg border border-base-200
            bg-base-300 px-4 py-2.5 text-text
            appearance-none cursor-pointer
            focus:border-primary focus:ring-2 focus:ring-primary/20
            disabled:bg-base-200 disabled:cursor-not-allowed
            ${error ? 'border-danger focus:border-danger focus:ring-danger/20' : ''}
          `}
					{...props}
				>
					<option value="">{placeholder}</option>
					{options.map((option, index) => {
						// Suporta tanto {value, label} quanto string simples
						const value = typeof option === 'object' ? option.value : option
						const label = typeof option === 'object' ? option.label : option
						return (
							<option key={`option-${index}-${value}`} value={value}>
								{label}
							</option>
						)
					})}
				</select>
				<div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
					<ChevronDown className="h-5 w-5 text-text-body" />
				</div>
			</div>
			{error && (
				<p className="mt-1 text-sm text-danger">{error}</p>
			)}
		</div>
	)
})

Select.displayName = 'Select'

export default Select
